module.exports = __webpack_public_path__ + "media/images/responsive/lp/online/reason_02-198242cff04c852b4b270b4a3676a4ad.png";